<ng-container *ngIf="user?.id">
  <ng-container *ngIf="
      currentUser?.id === user?.id || currentUser?.id === user?.id;
      else NotProfileTemplate
    ">
    <a [tabindex]="-1" type="button"
      class="flex items-center justify-center !px-2 max-md:!text-xs btn-blue-flat w-full h-full"
      [routerLink]="['/profile/', user.userName]" (click)="navigateToProfile()">
      پروفایل
    </a>
  </ng-container>
</ng-container>

<ng-template #NotProfileTemplate>
  <!-- ? Followed Button -->
  <ng-container *ngIf="
      user.followState == followState.OneWayYou ||
        user.followState == followState.TwoWay || user.followState == followState.Requested;
      else followTemplate
    ">
    <button [tabindex]="-1" type="button"
      class="btn-blue-outline !px-0 md:!px-2 w-full h-full flex items-center justify-center" [ngClass]="{
        '!min-h-8' : customHeight === 'min-h-8',
        '!min-h-10 !rounded-xl' : customHeight === 'min-h-10'
            }" (click)="followClicked()" [id]="'follow' + user.id">
      <span class="icon checkmark-filled text-sm mx-1"></span>
      <span class="text-xs font-regular"> {{ user.followStateText }}</span>
    </button>
  </ng-container>
</ng-template>

<!-- ? Follow Button -->
<ng-template #followTemplate>
  <button [tabindex]="-1" type="button"
    class="flex items-center justify-center max-md:!text-xs !px-0 md:!px-2 btn-blue-flat w-full h-full" [ngClass]="{
'!min-h-8' : customHeight === 'min-h-8',
'!min-h-10 !rounded-xl' : customHeight === 'min-h-10'
    }" (click)="followClicked()" [id]="'follow' + user.id">
    <ng-container *ngIf="user.followBack">
      <span class="icon arrow-reply-filled md:mx-1"></span>
    </ng-container>
    <span class="text-xs font-regular"> {{ user.followStateText }}</span>
  </button>
</ng-template>